<!--<div class="col-lg-12 text-center" *ngIf="getStationDetailLoader" style="margin-top: 50px;">-->
<!--  <img src="/assets/images/load.gif" />-->
<!--</div>-->

<!--<div *ngIf="!getStationDetailLoader" class="panel-group panel-group-control content-group-lg">-->

<!--  <div class="panel" *ngFor="let station of stationDetails let i = index" [attr.data-index]="i">-->
<!--    <div class="panel-heading">-->
<!--      <h6 class="panel-title">-->
<!--        <a data-toggle="collapse" [ngClass]="{'collapsed': i != 0}" href="#collapsible-control-group{{i}}"><strong>{{station.name}}</strong></a>-->
<!--      </h6>-->

<!--      <a [hidden]="(type == 'view')?true:false" class="delicon" (click)="delete(stationDetails[i]['id'])">-->
<!--        <i class="fa fa-trash" title="Delete Station" aria-hidden="true" style="color: #fff;background: red;padding:7px 8px 8px 8px; font-size:16px;border-radius:16px;cursor: pointer;"></i>-->
<!--      </a>-->

<!--    </div>-->
<!--    <div id="collapsible-control-group{{i}}" [ngClass]="{'in': i == 0}" class="panel-collapse collapse">-->
<!--      <div class="panel-body">-->

<!--        <div class="form-horizontal">-->

<!--          <fieldset class="content-group">-->

<!--          <div class="form-group">-->
<!--            <label class="control-label col-lg-2">-->
<!--              Station Name*-->
<!--            </label>-->
<!--            <div class="col-lg-10">-->
<!--              <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="stationDetails[i]['name']" placeholder="Enter station name" class="form-control">-->
<!--              <div *ngIf="formErrorStationName[i] && error">-->
<!--                <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorStationName[i]}}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="form-group">-->
<!--            <label class="control-label col-lg-2">-->
<!--              Station Id*-->
<!--              <div class="text-muted">(as maintained in vendor system)</div>-->
<!--            </label>-->
<!--            <div class="col-lg-10">-->
<!--              <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="stationDetails[i]['vendor_station_id']" placeholder="Enter Station Id" class="form-control">-->
<!--              <div *ngIf="formErrorStationId[i] && error">-->
<!--                <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorStationId[i]}}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="form-group">-->
<!--            <label class="control-label col-lg-2">-->
<!--              Contact Person Name-->
<!--            </label>-->
<!--            <div class="col-lg-10">-->
<!--              <input type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="stationDetails[i]['contact_person']" placeholder="Enter Contact Person Name" class="form-control">-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="form-group">-->
<!--            <label class="control-label col-lg-2">-->
<!--              Contact Person Designation-->
<!--            </label>-->
<!--            <div class="col-lg-10">-->
<!--              <input type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="stationDetails[i]['contact_person_designation']" placeholder="Enter Contact Person Designation" class="form-control">-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="form-group">-->
<!--            <label class="control-label col-lg-2">-->
<!--              Contact Person Email-->
<!--            </label>-->
<!--            <div class="col-lg-10">-->
<!--              <input type="email" [disabled]="(type == 'view')?true:false" [(ngModel)]="stationDetails[i]['contact_email']" placeholder="Enter Contact Person Email" class="form-control">-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="form-group">-->
<!--            <label class="control-label col-lg-2">-->
<!--              Contact Person Mobile Number-->
<!--            </label>-->
<!--            <div class="col-lg-10">-->
<!--              <input  type="number" [disabled]="(type == 'view')?true:false" onkeypress="return event.charCode >= 48 && event.charCode <= 57" [(ngModel)]="stationDetails[i]['contact_number']" placeholder="Enter Contact Person Mobile Number" class="form-control">-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="form-group" *ngIf="type == 'edit'">-->
<!--            <div class="col-lg-12" *ngIf="!updateStationLoader">-->

<!--              <div class="col-lg-1 pull-right">-->
<!--                <button (click)="validateStation(i)" type="submit" class="btn btn-primary">-->
<!--                  <strong>Update</strong>-->
<!--                </button>-->
<!--              </div>-->

<!--              <div class="col-lg-1 pull-right">-->
<!--                <button (click)="getStationDetail()" type="button" class="btn btn-danger">-->
<!--                  <strong>Reset</strong>-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="col-lg-12" *ngIf="updateStationLoader">-->
<!--              <span class="pull-right"><img style="width: 60%;" src="/assets/images/load.gif" /></span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </fieldset>-->
<!--      </div>-->

<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--</div>-->
<!--&lt;!&ndash; /collapsible with left control button &ndash;&gt;-->


<div class="text-center py-5" *ngIf="getStationDetailLoader">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div *ngIf="!getStationDetailLoader" class="accordion" id="stationAccordion">
  <div class="accordion-item mb-3" *ngFor="let station of stationDetails; let i = index" [attr.data-index]="i">
    <h2 class="accordion-header">
      <button class="accordion-button d-flex justify-content-between align-items-center"
              type="button"
              [ngClass]="{'collapsed': i != 0}"
              [attr.data-bs-target]="'#collapseStation' + i"
              data-bs-toggle="collapse"
              aria-expanded="i === 0 ? 'true' : 'false'"
              [attr.aria-controls]="'collapseStation' + i">
        <strong>{{station.name}}</strong>
        <button *ngIf="type !== 'view'" class=" btn-danger btn-sm ms-2 fa fa-trash"
                (click)="delete(stationDetails[i]['id']); $event.stopPropagation()"
                title="Delete Station">
          <i class="bi bi-trash"></i>
        </button>
      </button>
    </h2>
    <div [id]="'collapseStation' + i"
         class="accordion-collapse collapse"
         [ngClass]="{'show': i == 0}"
         [attr.aria-labelledby]="'headingStation' + i"
         data-bs-parent="#stationAccordion">
      <div class="accordion-body">
        <form class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Station Name*</label>
            <input autocomplete="off" pattern="^[^<>]*$" type="text"
                   name="stationName"
                   [disabled]="type == 'view'"
                   [(ngModel)]="stationDetails[i]['name']"
                   placeholder="Enter station name"
                   class="form-control">
            <div *ngIf="formErrorStationName[i] && error" class="text-danger fw-bold mt-1">
              *{{formErrorStationName[i]}}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">
              Station Id*
              <span class="text-muted d-block">(as maintained in vendor system)</span>
            </label>
            <input autocomplete="off" pattern="^[^<>]*$" type="text"
                   [disabled]="type == 'view'"
                   name="vendor_station_id"
                   [(ngModel)]="stationDetails[i]['vendor_station_id']"
                   placeholder="Enter Station Id"
                   class="form-control">
            <div *ngIf="formErrorStationId[i] && error" class="text-danger fw-bold mt-1">
              *{{formErrorStationId[i]}}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Contact Person Name</label>
            <input type="text"
                   [disabled]="type == 'view'"
                   name="contact_person"
                   [(ngModel)]="stationDetails[i]['contact_person']"
                   placeholder="Enter Contact Person Name"
                   class="form-control">
          </div>

          <div class="col-md-6">
            <label class="form-label">Contact Person Designation</label>
            <input type="text"
                   [disabled]="type == 'view'"
                   name="contact_person_designation"
                   [(ngModel)]="stationDetails[i]['contact_person_designation']"
                   placeholder="Enter Contact Person Designation"
                   class="form-control">
          </div>

          <div class="col-md-6">
            <label class="form-label">Contact Person Email</label>
            <input type="email"
                   [disabled]="type == 'view'"
                   name="contact_email"
                   [(ngModel)]="stationDetails[i]['contact_email']"
                   placeholder="Enter Contact Person Email"
                   class="form-control">
          </div>

          <div class="col-md-6">
            <label class="form-label">Contact Person Mobile Number</label>
            <input type="number"
                   [disabled]="type == 'view'"
                   onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                   name="contact_number"
                   [(ngModel)]="stationDetails[i]['contact_number']"
                   placeholder="Enter Contact Person Mobile Number"
                   class="form-control">
          </div>

          <div class="col-12" *ngIf="type == 'edit'">
            <div class="d-flex justify-content-end gap-2">
              <button (click)="getStationDetail()" type="button" class="btn btn-danger">
                <strong>Reset</strong>
              </button>
              <button (click)="validateStation(i)" type="submit" class="btn btn-primary" [disabled]="updateStationLoader">
                <span *ngIf="!updateStationLoader"><strong>Update</strong></span>
                <span *ngIf="updateStationLoader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
